module.exports = __webpack_public_path__ + "static/media/david.67f966cc.png";